import { IsString, Length, ValidateIf } from 'class-validator';

import { AttachmentTypeEnum } from '@onArte/shared/enums/common/attachments';

export class AttachmentModel {
  @IsString()
  @Length(32, 36)
  public id: string;

  public type: AttachmentTypeEnum;

  @IsString()
  public path: string;

  @IsString()
  public name: string;

  @IsString()
  @ValidateIf((object: unknown, value: unknown) => value !== null)
  public objectName: string | null;

  constructor(id: string, type: AttachmentTypeEnum, path: string, name: string, objectName: string | null) {
    this.id = id;
    this.type = type;
    this.path = path;
    this.name = name;
    this.objectName = objectName;
  }
}
